module.exports = __webpack_public_path__ + "img/hawaii_screen.4174ff21.png";